import { fRequest } from 'utilities/api';
import config from 'init/config';

export const api_getesi_data = runId =>
  fRequest(`${config.buckRootUrl}/api/reports/esi-data/${runId}/`, {
    method: 'GET'
  });

export const api_get_qcoligodoc_data = (orderId, search) => {
  let forwarded_qs =
    search && search.length > 1 ? '&' + search.substring(1) : '';
  let url = `${
    config.buckRootUrl
  }/api/reports/qc-docs/${orderId}/oligo-esi/?active=true${forwarded_qs}`;
  return fRequest(url, { method: 'GET' });
};
